import { Badge, DirectoryTable, PageHeader, useFormatters } from '@lumlab/platform-ui';
import { useTranslation } from 'react-i18next';
import type { DirectoryUser } from '../contract/index.ts';
import { useDirectory } from './queries.ts';

export function UsersPage() {
    const { t } = useTranslation();
    const format = useFormatters();
    const users = useDirectory<DirectoryUser>('/api/admin/users');
    return (
        <>
            <PageHeader title={t('platform.admin.users')} description={t('platform.admin.usersDescription')} />
            <DirectoryTable
                items={users.data?.items ?? []}
                total={users.data?.total ?? 0}
                loading={users.isPending}
                error={users.error}
                search={users.search}
                onSearchChange={users.setSearch}
                page={users.page}
                pageSize={users.pageSize}
                onPageChange={users.setPage}
                columns={[
                    { key: 'name', label: t('platform.admin.name'), render: (user) => user.name },
                    { key: 'email', label: t('platform.auth.email'), render: (user) => user.email },
                    {
                        key: 'role',
                        label: t('platform.admin.role'),
                        render: (user) => (
                            <Badge tone={user.administrator ? 'info' : 'neutral'}>
                                {user.administrator ? t('platform.admin.administrator') : t('platform.admin.customer')}
                            </Badge>
                        ),
                    },
                    {
                        key: 'memberships',
                        label: t('platform.admin.organizations'),
                        render: (user) => format.number(user.memberships),
                    },
                    {
                        key: 'createdAt',
                        label: t('platform.admin.createdAt'),
                        render: (user) => format.date(new Date(user.createdAt)),
                    },
                ]}
            />
        </>
    );
}
